// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import ModelAbstract from '../modelAbstract/modelAbstract';

export default class TranslationSummaryModel extends ModelAbstract {
	_id: string;
	category: string;
	lang: string;
	sumConfidence: number;
	minConfidence: number;
	maxConfidence: number;
	count: number;
	answers: any[];

	constructor(data: any) {
		super();

		this._id = data._id;
		this.category = data.category;
		this.lang = data.lang;
		this.sumConfidence = data.sumConfidence;
		this.minConfidence = data.minConfidence;
		this.maxConfidence = data.maxConfidence;
		this.count = data.count;
		this.answers = data.answers;

		this.mapData();
	}

	mapData(): void {}

	validate(data: any): string {
		if (!data.error) {
			return null;
		}

		if (data.error) {
			return data.error;
		}

		return 'Unexpected error';
	}

	static handleError(error: Error): void {
		console.log(error);
	}
}
